<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-10 col-xl-12 col-xxl-10 col-xxxl-9">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">
            Terminez la creation du compte
          </h4>

          <div class="row">
            <div class="alert alert-success" role="alert" v-if="isInvalid">
              <!-- <h4 class="alert-heading fw-bold mb-10">Well done!</h4> -->
              <p class="fs-md-15 fs-lg-16">
                Ce lien est invalide.
              </p>
            </div>
          </div>

          <form @submit.prevent="handleRegister" v-if="!isInvalid" class="row g-3">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="name" class="form-label">Nom et prénom *</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  :value="customerData.name"
                  name="name"
                  placeholder="Nom et prénom *"
                  disabled
                />
              </div>
            </div>

            <!-- email -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="email" class="form-label">Adresse electronique *</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  :value="customerData.email"
                  name="email"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="store_name" class="form-label">Votre Store</label>
                <input
                  type="text"
                  class="form-control"
                  id="store_name"
                  :value="customerData.store_name"
                  name="store_name"
                  placeholder="Votre store"
                  disabled
                />
              </div>
            </div>

            <!-- phone -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="phone" class="form-label">Numéro de téléphone *</label>
                <input
                  type="text"
                  class="form-control"
                  id="phone"
                  :value="customerData.phone"
                  name="phone"
                  placeholder="Numéro de téléphone *"
                  disabled
                />
              </div>
            </div>

            <!-- store -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="store" class="form-label">Nom du magasin *</label>
                <input
                  type="text"
                  class="form-control"
                  id="store"
                  v-model="customerData.store_name"
                  name="store"
                  placeholder="Nom du magasin *"
                  required
                />
              </div>
            </div>

            <!-- marque -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="brand" class="form-label">Marque *</label>
                <input
                  type="text"
                  class="form-control"
                  id="brand"
                  v-model="customerData.brand"
                  name="brand"
                  placeholder="Marque *"
                  required
                />
              </div>
            </div>

            <!-- ville -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="city" class="form-label">Ville *</label>

                <v-select
                  class="custom-select-height"
                  v-model="customerData.city"
                  label="name"
                  :options="citiesList"
                />

             
              </div>
            </div>

            <!-- ville de retour -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cityReturn" class="form-label">Ville de retour *</label>
                <v-select
                  class="custom-select-height"
                  v-model="customerData.cityReturn"
                  :options="citiesList"
                  label="name"
                >
                </v-select>
              </div>
            </div>

            <!-- Adresse -->
            <div class="col-12">
              <div class="mb-3">
                <label for="address" class="form-label">Adresse *</label>
                <textarea
                  class="form-control"
                  id="address"
                  v-model="customerData.address"
                  name="address"
                  rows="2"
                  placeholder="Adresse *"
                  required
                ></textarea>
              </div>
            </div>

            <!-- password -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="password" class="form-label">Mot de passe *</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  v-model="customerData.password"
                  name="password"
                  placeholder="*****"
                  required
                />
              </div>
            </div>

            <!-- c_password -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="c_password" class="form-label">Confirmation de mot de passe *</label>
                <input
                  type="password"
                  class="form-control"
                  id="c_password"
                  v-model="customerData.c_password"
                  name="c_password"
                  placeholder="Confirmation de mot de passe *"
                  required
                />
              </div>
            </div>

            <!-- cin -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cin" class="form-label">Carte d'identité nationale *</label>
                <input
                  type="text"
                  class="form-control"
                  id="cin"
                  v-model="customerData.cin"
                  name="cin"
                  placeholder="Carte d'identité nationale *"
                  required
                />
              </div>
            </div>

            <!-- company -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="company_type" class="form-label">Type d'entereprise *</label>
                <v-select
                  class="custom-select-height"
                  v-model="customerData.company_type"
                  label="name"
                  :options="typeClients"
                />
                
              </div>
            </div>

            <!-- rc -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="rc" class="form-label">RC</label>
                <input
                  type="text"
                  class="form-control"
                  id="rc"
                  v-model="customerData.rc"
                  name="rc"
                  placeholder="RC"
                />
              </div>
            </div>
            <div class="col-md-6">
               <div class="mb-3">
                <label for="ice" class="form-label">ICE</label>
                <input
                  type="text"
                  class="form-control"
                  id="ice"
                  v-model="customerData.ice"
                  name="ice"
                  placeholder="ICE"
                  :required="customerData.company_type?.name.trim().toLowerCase() === 'sarl' ? true : false"
                />
              </div>
            </div>

            <!-- website -->
            <div class="col-12">
              <div class="mb-3">
                <label for="website" class="form-label">Site web</label>
                <input
                  type="url"
                  class="form-control"
                  id="website"
                  v-model="customerData.website"
                  name="website"
                  placeholder="www.monsite.ma"
                />
              </div>
            </div>

            <!-- bank -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bank" class="form-label">Nom du banque *</label>
                <v-select
                  class="custom-select-height"
                  v-model="customerData.bank"
                  label="name"
                  :options="bankList"
                />
              </div>
            </div>

            <!-- rib -->
            <div class="col-md-6">
              <div class="mb-3">
                <label for="rib" class="form-label">RIB (24 Numéro) *</label>
                <input
                  type="text"
                  class="form-control"
                  id="rib"
                  v-model="customerData.rib"
                  name="rib"
                  placeholder="RIB (24 Numéro) *"
                  maxlength="24"
                  required
                />
              </div>
            </div>

            <div class="col-12">
              <hr/>
            </div>

            <div class="col-12">
              <button
                type="submit"
                class="btn btn-primary w-100"
                :disabled="isInvalid || load"
              >
                Terminer
                <span v-if="load" class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useSanitize } from "@/composables/useSanitize";
import api from "@/utils/axios";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },

    token: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { showToast } = useAppToast();
    const { sanitizeText, sanitizeUrl } = useSanitize();
    const router = useRouter();

    const form = ref({
      email: "",
      name: "",
      phone: "",
      city: "",
      status: 1,
      store: {
        name: "",
        id: "",
      },
    });
    const customerData = reactive({
      name: "",
      email: "",
      phone: "",
      store_name: "",
      brand: "",
      city: null,
      cityReturn: null,
      address: "",
      password: "",
      c_password: "",
      cin: "",
      company_type: null,
      rc: "",
      ice: "",
      website: "",
      bank: null,
      rib: "",
      store: {
        name: "",
        id: "",
      },
    });
    const load = ref(false);
    const isCreat = ref(false);

    const isInvalid = ref(false);

    const typeClients = ref<any[]>([]);
    const citiesList = ref<any[]>([]);
    const bankList = ref<any[]>([]);


    const getCustomer = async () => {
      try {
        const response = await api.get(`/api/auth/client/showCustomer`, {
          params: { id_cust: props.id, active_code: props.token },
        });
        if (response && response.data) {
          if (response.data.message == "invalid path") {
            isInvalid.value = true;
          } else {
            Object.assign(customerData, response.data.data);
          }

          console.log(customerData);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    onMounted(async () => {
      getCustomer();
      try {
        const response = await api.get("/api/auth/citiesList");
        if (response && response.data) {
          citiesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/typeClients");
        if (response && response.data) {
          typeClients.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/banks");
        if (response && response.data) {
          bankList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }
    });

    // Coupon validation function using composition API and axios
    const errorCoupon = ref(false);
    const msgCoupon = ref("");
    const coupon = ref("");

    const checkCoupon = async () => {
      errorCoupon.value = false;
      msgCoupon.value = "";
      if (coupon.value) {
        let data = new FormData();
        data.append("coupon", coupon.value);
        try {
          const res = await api.post("/api/auth/CheckCoupon", data);
          if (res.data === "success") {
            // Coupon valid, do nothing or handle success
          } else if (res.data.msg === "no coupon") {
            errorCoupon.value = true;
            msgCoupon.value = res.data.str;
            showToast("Code coupon est invalide", "error");
          } else if (res.data.msg === "invalid coupon") {
            errorCoupon.value = true;
            msgCoupon.value = res.data.str;
            showToast("Code coupon est expiré", "error");
          }
        } catch (e) {
          showToast("Something went wrong! Please try again", "error");
        }
      } else {
        errorCoupon.value = false;
      }
    };

    // Form validation function using composition API
    const handleRegister = async () => {
      const regex = /^[a-zA-Z0-9\s]+$/;
      // Example: Add your form fields here
      if (
        customerData.company_type &&
        typeof customerData.company_type.name === 'string' &&
        customerData.company_type.name.trim().toLowerCase() === 'sarl' &&
        !customerData.ice
      ) {
        showToast("ICE est obligatoire pour le type d'entreprise SARL", "error");
        return;
      }
      if (
        customerData.name &&
        customerData.email &&
        customerData.phone &&
        customerData.city &&
        customerData.store_name &&
        regex.test(customerData.store_name) &&
        customerData.company_type &&
        errorCoupon.value === false
      ) {
        let data = new FormData();
        data.append("id_customer", sanitizeText(props.id));
        data.append("active_code", sanitizeText(props.token));
        data.append("email", sanitizeText(customerData.email));
        data.append("store", sanitizeText(customerData.store_name));
        data.append("name", sanitizeText(customerData.name));
        data.append("phone", sanitizeText(customerData.phone));
        data.append("city", sanitizeText(customerData.city));
        data.append("coupon", sanitizeText(coupon.value));
        data.append('password', customerData.password);
        data.append('c_password', customerData.c_password);
        data.append('city_id', sanitizeText(String(customerData.city?.id ?? '')));
        data.append('cityReturn', sanitizeText(String(customerData.cityReturn?.id ?? '')));
        data.append('adresse', sanitizeText(customerData.address || ""));
        data.append('website', sanitizeUrl(customerData.website || ""));
        data.append('brand', sanitizeText(customerData.brand || ""));
        data.append('type_client', sanitizeText(String(customerData.company_type?.id ?? '')));
        data.append('company_type', sanitizeText(customerData.company_type?.name ?? ''));
        data.append('ice', sanitizeText(customerData.ice || ""));
        data.append('rc', sanitizeText(customerData.rc || ""));
        data.append('id_bank', sanitizeText(String(customerData.bank?.id ?? '')));
        data.append('bank', sanitizeText(customerData.bank?.name ?? ''));
        data.append('rib', sanitizeText(customerData.rib || ""));
            

        load.value = true;
        try {
          const res = await api.post("/api/auth/client/CompletRegister", data);
          load.value = false;
          if (res.data.message === "success") {
            showToast("Votre compte est ajouté avec succès", "success");
          // console.log("Login successful:", response.data);
          // Redirect user after login
            router.push("/login");
            // Redirect or reset form
          } else if (res.data.message === "email exist") {
            showToast("Email saisi est déjà existe!", "error");
          } else if (res.data.message === "not match") {
            showToast("Les mots de passes sont différents", "error");
          } else if (res.data.message === "store exist") {
            showToast("Le nom du magasin est déjà existe!", "error");
          } else if (res.data.message === "rib exist") {
            showToast("Ce RIB est déjà existe!", "error");
          } else if (res.data.message === "cin exist") {
            showToast("Carte d'identité nationale est déjà existe!", "error");
          } else if (res.data.message === "error code") {
            showToast(
              "Le code RIB ne correspond pas à la banque insérée !",
              "error"
            );
          }
        } catch (e) {
          load.value = false;
          showToast("Something went wrong! Please try again", "error");
        }
      } else {
        showToast("Merci de remplir tous les champs", "error");
      }
    };

    return {
      form,
      load,
      isCreat,
      bankList,
      typeClients,
      citiesList,
      customerData,

      handleRegister,
      checkCoupon,
      errorCoupon,
      msgCoupon,
      coupon,
      isInvalid,
    };
  },
});
</script>
    